(ns ui.view.transaction-process.modals.transition.event
  (:require
   [common.transaction-process.templates.registry :as template-registry]
   [common.util :as cu]
   [re-frame.core :as rf]
   [ui.state.session.cofx :as session-cofx]
   [ui.view.transaction-process.event :as tp-event]
   [ui.view.transaction-process.modals.transition.model :as model]
   [ui.view.transaction-process.model :as tp-model]
   [ui.view.transaction-process.util :as tp-util]))

(rf/reg-event-fx
 ::open
 [rf/trim-v (rf/inject-cofx ::session-cofx/session-context)]
 (fn [{:keys [db session-context]} [{:keys [state-path] :as _ctx}
                                    {:keys [transition value-lookup missing blocking-sub-entities]}]]
   (let [{:keys [default-currency]} session-context
         server     (get-in db (tp-model/server-state-full-path state-path))
         draft      (get-in db (tp-model/draft-full-path state-path))
         process    (merge server draft)
         template   (template-registry/get-template (:transaction-process/template-kw server))
         ;; Lux-ness lives on the TP (:transaction-process/lux-fund?), so the process
         ;; map is the complete rule-evaluation lookup — no vehicle resolution needed.
         vlookup    (or value-lookup process)
         vkws       (model/visible-field-kws {:transition   transition
                                              :template     template
                                              :value-lookup vlookup})
         required-field-kws (model/mandatory-field-kws {:visible-field-kws vkws
                                                        :template          template
                                                        :value-lookup      vlookup})
         skip-slot-controls (model/skip-slot-controls {:transition transition
                                                       :template   template})
         field-vals (model/init-field-vals {:visible-field-kws vkws
                                            :field-configs     (:template/fields template)
                                            :entity-data       process
                                            :default-currency  default-currency})
         skip-slot-vals (model/init-skip-slot-vals skip-slot-controls process)]
     {:db (assoc-in db (model/state-full-path state-path)
                    {:open?                 true
                     :transition            transition
                     :value-lookup          vlookup
                     :field-vals            field-vals
                     :skip-slot-controls    skip-slot-controls
                     :skip-slot-vals        skip-slot-vals
                     :required-field-kws    required-field-kws
                     :show-errors?          false
                     :confirmed?            false
                     :missing               missing
                     :blocking-sub-entities blocking-sub-entities})})))

(rf/reg-event-db
 ::set-field-val
 [rf/trim-v]
 (fn [db [{:keys [state-path] :as _ctx} kw value]]
   (assoc-in db (conj (model/key-full-path state-path :field-vals) kw) value)))

(rf/reg-event-db
 ::set-confirmed
 [rf/trim-v]
 (fn [db [{:keys [state-path] :as _ctx} value]]
   (assoc-in db (model/key-full-path state-path :confirmed?) value)))

(rf/reg-event-db
 ::set-skip-slot
 [rf/trim-v]
 (fn [db [{:keys [state-path] :as _ctx} slot-kw value]]
   (assoc-in db (conj (model/key-full-path state-path :skip-slot-vals) slot-kw) value)))

(rf/reg-event-db
 ::close
 [rf/trim-v]
 (fn [db [{:keys [state-path] :as _ctx}]]
   (assoc-in db (model/state-full-path state-path) nil)))

(rf/reg-event-fx
 ::confirm
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path] :as ctx}]]
   (let [{:keys [transition value-lookup field-vals skip-slot-controls skip-slot-vals
                 missing required-field-kws blocking-sub-entities]}
         (get-in db (model/state-full-path state-path))
         field-vals (merge field-vals
                           (model/skip-slot-field-vals skip-slot-controls skip-slot-vals))
         field-errors (tp-util/validate-transition-field-values
                       (:transition/field-validations transition)
                       (merge value-lookup field-vals))
         missing-required (filterv #(cu/blank-value? (get field-vals %)) required-field-kws)]
     (if (or (seq missing) (seq missing-required) (seq field-errors) (seq blocking-sub-entities))
       {:db (assoc-in db (model/key-full-path state-path :show-errors?) true)}
       {:db (assoc-in db (model/state-full-path state-path) nil)
        :fx [[:dispatch (cond
                          (model/backward-transition? transition)
                          [::tp-event/change-stage ctx (:transition/to transition) field-vals]

                          (= :reject (:transition/action transition))
                          [::tp-event/reject-transaction ctx]

                          (:transition/close-action? transition)
                          [::tp-event/complete-transaction ctx field-vals]

                          :else
                          [::tp-event/change-stage ctx (:transition/to transition) field-vals])]]}))))
